import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import PostHookAccount from "../../../../Api/PostHookAccount";
import AlertComponent from "../../../../Components/AlertComponent";

const AddAccountForm = ({ user, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [accLoading, accResponse, accRequest] = PostHookAccount();
  const selectedAccountType = watch("account_type");

  const accountTypes = [
    { label: "Shareholder", value: "shareholder" },
    { label: "SMS Supplier", value: "sms_supplier" },
    { label: "Airtime supplier", value: "airtime_supplier" },
    { label: "Airtime inventory", value: "airtime_inventory" },
  ];

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = (data) => {
    const account_t = data.account_type;
    let formDataShareholder = {
      notification: "Yes",
      notification_type: "sms",
      admin_channel: "",
      callback_url: "",
      role: user.role,
    };
    let url = "";

    if (account_t === "shareholder") {
      formDataShareholder = {
        ...formDataShareholder,
        shareholder_entity_id: user.id,
        type: account_t,
      };
      url = "api_1";
    } else if (account_t === "sms_supplier") {
      formDataShareholder = {
        ...formDataShareholder,
        supplier_entity_id: user.id,
        type: account_t,
      };
      url = "api_2";
    } else if (account_t === "airtime_inventory") {
      formDataShareholder = {
        ...formDataShareholder,
        inventory_item_entity_id: user.id,
        type: "airtime_inventory",
      };
      url = "api_3";
    } else if (account_t === "airtime_supplier") {
      formDataShareholder = {
        ...formDataShareholder,
        supplier_entity_id: user.id,
        type: "airtime_supplier",
      };
      url = "api_2";
    }

    const customerProps = {
      url: url,
      body: formDataShareholder,
    };

    accRequest(customerProps);
  };

  useEffect(() => {
    if (
      accResponse &&
      accResponse.status === 200 &&
      accResponse.data.StatusCode === 0
    ) {
      setSnackbar({
        open: true,
        severity: "success",
        message: "Account created successfully!",
      });

      setTimeout(() => {
        onClose();
        if (onSuccess) onSuccess();
      }, 1000);
    } else if (accResponse) {
      const errorMessage =
        accResponse?.data?.StatusMessage ??
        accResponse?.data?.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  }, [accResponse, onClose, onSuccess]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl fullWidth sx={{ mt: "5px" }} error={!!errors.account_type}>
        <InputLabel id="account_type">Account type</InputLabel>
        <Select
          labelId="account_type"
          id="account_type"
          defaultValue=""
          label="Account type"
          {...register("account_type", { required: true })}
        >
          {accountTypes.map((account) => (
            <MenuItem value={account.value} key={account.value}>
              {account.label}
            </MenuItem>
          ))}
        </Select>
        {errors.account_type && (
          <FormHelperText>Select an account type!</FormHelperText>
        )}
      </FormControl>

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" type="reset" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={accLoading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default AddAccountForm;
